import React, { useCallback } from 'react';
import toast from 'react-hot-toast';
import { Notification, NotificationVariant } from '../components/atoms/notification/Notification';

const DEFAULT_TOAST_DURATION = 5000;

/** The hook-free form of `useToast`, for code that runs outside React (the query client's caches). */
export const showToast = (title: string, description: string, variant: NotificationVariant, duration?: number) => {
  toast.custom((toast) => <Notification title={title} description={description} variant={variant} toast={toast} />, {
    duration: duration ?? DEFAULT_TOAST_DURATION,
  });
};

export const useToast = () => {
  const addToast = useCallback(
    (title: string, description: string, variant: NotificationVariant, duration?: number) => {
      showToast(title, description, variant, duration);
    },
    []
  );
  const addSuccessToast = useCallback(
    (title: string, description: string, duration?: number) => {
      addToast(title, description, 'success', duration);
    },
    [addToast]
  );

  const addWarningToast = useCallback(
    (title: string, description: string, duration?: number) => {
      addToast(title, description, 'warning', duration);
    },
    [addToast]
  );

  const addErrorToast = useCallback(
    (title: string, description: string, duration?: number) => {
      addToast(title, description, 'error', duration);
    },
    [addToast]
  );

  return { addSuccessToast, addWarningToast, addErrorToast };
};
